<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-column" scrollable centered size="lg">
      <template #modal-title>
        <i class="fas fa-columns"></i> Quadro - Configuração
      </template>
      <div class="form-group row pt-2 pb-5 mb-5">
        <div class="col-md-12">
          <h5 class="text-third"><i class="fas fa-font" /> Título</h5>
        </div>

        <div id="board-details" class="col-md-12 mb-1">
          <b-form-input v-model="boardName" placeholder="Digite o nome do quadro" />
        </div>

        <TableMovimentacaoQuadro
          :boardObj="this.board" @Update="reloadColumns" v-if="this.board"
        />

        <div class="col-md-6 pt-4">
          <h5 class="text-third m-0"><i class="fas fa-columns" /> Colunas</h5>
        </div>

        <div class="col-md-6 pt-4 text-right">
          <button type="button" class="btn rounded btn-third btn-sm" @click="onAdd"><i class="fas fa-plus-circle" /> Adicionar</button>
        </div>

        <div class="col-md-12 pb-3 detail">
          Clique e arraste para alterar as posições
        </div>

        <div class="col-md-12">
          <draggable
            :list="localColumns"
            handle=".handle"
            v-on:update="onMoveColumns"
            :animation="200"
            ghost-class="ghost-card"
            class="draggable-area"
          >
            <div
              v-for="(column, index) in localColumns"
              :key="column.id"
              class="draggable-column column-configuration pointer"
            >
              <div class="handle mx-1">
                <i class="fas fa-grip-vertical"/>
              </div>
              <div
                v-if="column.id !== editing.columnID"
                class="editable-area"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <span v-if="column.value" class="text-danger text-bold">{{column.value}}%</span> {{column.name}}

                  <div>
                    <b-dropdown variant="link" size="sm" no-caret class="mx-2">
                      <template slot="button-content">
                      <i v-if="column.eventoColuna.some(event => event !== 0 && event !== 5)" class="fas fa-bolt text-warning icone-grid mx-2" v-b-tooltip.hover title="Clique para editar a ação" style="padding-top: 3px;"/>
                      <i v-else-if="shouldShowIcon(column)" class="fas fa-bolt text-warning icone-grid mx-2" v-b-tooltip.hover title="Clique para editar a ação" style="padding-top: 3px;"/>
                      <i v-else class="fas fa-bolt icone-grid mx-2" v-b-tooltip.hover title="Clique para editar a ação" style="padding-top: 3px; color: #818181;"/>
                    </template>
                    <span class="sr-only">Clique para adicionar uma ação</span>
                    <b-dropdown-header><i class="fas fa-bolt"/>&nbsp;&nbsp;&nbsp;<strong>Selecione uma Ação</strong></b-dropdown-header>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.SEM_ACAO)">
                      <i class="fas fa-times text-danger"></i>
                      Sem Ação
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.SEM_ACAO)"/>
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.FOLLOW_UP)">
                        <i class="fas fa-bullhorn text-secondary"></i>
                        Follow Up
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.FOLLOW_UP)"/>
                      </b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.PRODUTO)">
                        <i class="fas fa-credit-card text-secondary"></i>
                        Novo Produto
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.PRODUTO)"/>
                      </b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.RESPONSAVEL)">
                      <i class="fas fa-user text-secondary"></i>
                      Responsável
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.RESPONSAVEL)"></i>
                    </b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.SERASA)">
                      <i class="fas fa-search-dollar text-secondary"></i>
                      Serasa
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.SERASA)"></i>
                    </b-dropdown-item>
                    <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="showMovimentacaoModal(column, index)">
                      <i class="fas fa-random text-secondary"></i>
                      Movimentação
                      <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.MOVIMENTACAO) && shouldShowIcon(column)"></i>
                    </b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="showNotificacaoModal(column, index)">
                        <i class="fas fa-bell text-secondary"></i>
                        Notificar Usuário
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.NOTIFICACAO)"></i>
                      </b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0);" @click.native.capture.stop="onSetAction(column, index, columnEvents.ENVIO_WHATSAPP)">
                        <i class="fas fa-comment text-secondary"></i>
                         Envio de WhatsApp
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.ENVIO_WHATSAPP)"></i>
                      </b-dropdown-item>
                      <b-dropdown-item v-if="board.tipoBoard === 'AJUIZAMENTO'" href="javascript:void(0);" @click.native.capture.stop="showBlockAjuizamentoModal(column, index)">
                        <i class="fas fa-lock text-secondary"></i>
                        Bloquear Ajuizamento
                        <i class="fas fa-check pl-3 text-success" v-if="column.eventoColuna.some(event => event === columnEvents.BLOQUEAR_AJUIZAMENTO)"></i>
                      </b-dropdown-item>
                  </b-dropdown>
                    <i
                      class="fas fa-edit text-third mx-2"
                      @click.stop.prevent="onEdit(column)"
                    />
                    <template>
                      <i v-if="!column.inative"
                         class="fas fa-minus-circle text-danger mx-2"
                         v-b-tooltip.hover title="Clique para inativar"
                         @click="onChangeColumnStatus(index, true)"
                      />
                      <i v-else
                         class="fas fa-minus-circle mx-2"
                         v-b-tooltip.hover title="Clique para ativar"
                         @click="onChangeColumnStatus(index, false)"
                      />
                    </template>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="w-100 flex flex-column flex-wrap"
              >
                <div class="form-group row align-items-center">
                  <div class="col-md-6 d-flex justify-content-md-start align-items-center">
                    <b-form-input
                      :maxlength="20"
                      autofocus
                      id="editing-title"
                      v-model="column.name"
                      class="editing-hidden"
                    />
                    <color-picker
                      v-model="column.color"
                      :position="{ top: '0px', left: '-252px' }"
                    />

                  </div>
                  <div class="col-md-4">
                    <b-form-checkbox
                    id="obrigatorio"
                    v-model="column.obrigatorio"
                    name="obrigatorio"
                    style="font-size: 14px; display: flex; align-items: center; height: 100%;"
                    >
                    Passagem Obrigatória
                    </b-form-checkbox>
                  </div>
                  <div
                    style="width: 10%;"
                    class="col-md-2 d-flex justify-content-end align-items-center"
                  >
                    <i
                      class="fas fa-check text-success"
                      @click="onSave(column)"
                    />
                    <i
                      class="fas fa-times-circle text-danger ml-2"
                      @click="onCancel(column)"
                    />
                  </div>
                </div>
                <div class="mt-1">
                  <b-form-textarea
                    v-model="column.observacao"
                    placeholder="Digite uma breve descrição sobre a coluna"
                    rows="4"
                    size="5"
                    :noResize="true"
                    class="editing-hidden"
                  />
                </div>
                <!-- <div class="mt-1 d-flex align-items-center"> -->

                <div class="form-group row">
                  <div class="col-md-4">
                    <label class="mb-0" style="font-weight: 100; font-size: 12px;" for="hoursUntilAlert">Tempo máximo na coluna</label>
                    <b-form-input
                    id="hoursUntilAlert"
                    type="number"
                    placeholder="Digite as horas"
                    v-model="column.hoursUntilAlert"
                    class="editing-hidden"
                    v-mask="'####'"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="mb-0" style="font-weight: 100; font-size: 12px;" for="hoursUntilAlertContact">Tempo máximo sem contato positivo</label>
                    <b-form-input
                    id="hoursUntilAlertContact"
                    type="number"
                    placeholder="Digite as horas"
                    v-model="column.hoursUntilAlertContact"
                    class="editing-hidden"
                    v-mask="'####'"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="mb-0" style="font-weight: 100; font-size: 12px;" for="percentage">Percentual de fechamento</label>
                    <b-form-input
                    id="percentage"
                    type="text"
                    placeholder="%"
                    v-model="column.value"
                    class="editing-hidden"
                    v-mask="'###'"
                    />
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-between mt-1" style="gap: 1rem;">
                  <div class="w-50">
                    <b-form-checkbox
                    id="obrigatorio"
                    v-model="column.obrigatorio"
                    name="obrigatorio"
                    style="font-size: 14px; display: flex; align-items: center; height: 100%; padding-top: 16px;"
                    >
                    Passagem Obrigatória
                  </b-form-checkbox>
                </div>
                </div> -->
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn rounded btn-third btn-sm"
            v-on:click="onSave"
            v-b-tooltip.hover
            :title="'Salvar'"
            @click="onSaveBoardColumn"
          >
            <i class="fas fa-check-circle"></i><span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
    <SerasaModal v-if="serasaModalAttributes.length" :attributes="serasaModalAttributes" @closeModal="hideSerasaModal" ref="SerasaModal"/>
    <HsmModal v-if="hsmModalAttributes.length" :attributes="hsmModalAttributes" @closeModal="hideHsmModal" ref="HsmModal"/>
    <ModalMovimentacaoColuna
        v-if="movimentacaoModalOpen"
        ref="ModalMovimentacaoColuna"
        :column="movimentacaoModalItems[0]"
        :index="movimentacaoModalItems[1]"
        v-on:Reload="hideMovimentacaoModal"
        v-on:Update="() => {hideModal(); hideMovimentacaoModal(); $emit('Back')}"
        v-on:onSaveBoardColumn="() => {hideModal(); hideMovimentacaoModal(); $emit('Back')}"
      />
    <ModalNotificacao
      v-if="notificacaoModalOpen"
      ref="ModalNotificacao"
      :column="notificacaoModalItems[0]"
      :index="notificacaoModalItems[1]"
      v-on:Reload="hideNotificacaoModal"
      @update="closeAndSaveNotificacaoModal"/>
    <ModalBlockAjuizamento
      v-if="blockAjuizamentoModalOpen"
      ref="ModalBlockAjuizamento"
      :column="blockAjuizamentoModalItems[0]"
      :index="blockAjuizamentoModalItems[1]"
      v-on:Reload="hideBlockAjuizamentoModal"
      @update="closeAndSaveBlockAjuizamentoModal"/>
  </div>
</template>
<script>
import BoardCollumns from './boardcollumns.js'
export default BoardCollumns
</script>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/boardcollumns.vue